import classNames from 'classnames'
import React from 'react'
import GeoentityItemThumbnail from '../genericComponents/GeoentityItemThumbnail'
import s from './GeoentityListItem.less'
import GoToGeoentityButton from './GoToGeoentityButton'
import PromoIcon from './promo.svg'
import useGeoentityListItem from './useGeoentityListItem'
import GeoentityListItemDetails from './GeoentityListItemDetails'
import { useGeoentityItemCTALabel } from './useGeoentityItemCTALabel'

const GeoentityListItem = ({ poi, noExternalButtons, type, seoHideImages = false }) => {
  const { name, rubric = {}, additionalInfo = {}, addressLabel } = poi
  const { promo } = additionalInfo
  const illustrationUrl = additionalInfo?.illustration?.url

  const { label: rubricLabel } = rubric

  const { displayOptions, geoentityImageAlt, liMouseListeners, isSelected } = useGeoentityListItem(poi)
  const { tagInfo } = useGeoentityItemCTALabel(poi)

  return (
    <li className={classNames(s.item, isSelected && s.selectedItem)} {...liMouseListeners}>
      <div className={s.content}>
        <div className={s.name}>
          <GoToGeoentityButton poi={poi} className={s.link} isLink tagInfo={tagInfo}>
            {name}
          </GoToGeoentityButton>
          {promo && (
            <div className={s.promo}>
              <img src={PromoIcon} alt="Promo icône" /> Promo
            </div>
          )}
        </div>
        {displayOptions.address && <div className={s.text}>{addressLabel}</div>}
        {displayOptions.rubric && <div className={s.text}>{rubricLabel}</div>}
        <GeoentityListItemDetails type={type} noExternalButtons={noExternalButtons} poi={poi} />
      </div>
      <GeoentityItemThumbnail
        className={s.illustration}
        src={illustrationUrl}
        alt={geoentityImageAlt}
        seoHideImage={seoHideImages}
      />
    </li>
  )
}

export default GeoentityListItem
